var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{attrs:{"rotate":270,"size":_vm.size,"width":15,"value":_vm.percent,"color":_vm.color}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]),_c('div',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }